import { Component, Watch } from 'vue-property-decorator'
import { Getter, State, Mutation, Action } from 'vuex-class'
import BasePage from '@/views/BasePage/BasePage'
import Loading from '@/components/loading/loading'
import CellphoneInput from '@/components/cellphoneInput/cellphoneInput'

@Component({
  components: {
    Loading,
    CellphoneInput
  },
  beforeRouteLeave(to, from, next) {
    const w = window as any;
    try {
      // w.Intercom('update', {
      //   hide_default_launcher: false
      // });
    } catch (error) {
      // Do Nothing!
    }
    next();
  }
})
export default class Login extends BasePage {

  // Actions
  @Action action_getLoginEmail;
  @Action action_postLogin;
  @Action action_changeUserCommerce;
  @Action action_postResetPassword;
  @Action action_getLoginCellSearch;

  // Getters
  @Getter getPathTemporal;
  @Getter getCity;
  
  // Mutations
  @Mutation LOGIN_HELPER;
  
  isUser = false;
  loading = false;

  // Cellphone Login Attributes
  isCellphone = false;
  cellphoneValue = "";

  // Email Login Attributes
  isEmail = false;
  emailValue = "";
  passwordValue = "";

  // Login attributes
  isSignUp = true;
  correct = true;
  isWrong = "";
  enableButton = false;

  loginHelper = {
    isLogin: false,
    cellphoneValue: "",
    emailValue: "",
    validated: false
  }

  get getMainTitle() {
    let response = "";
    if(this.isCellphone) {
      response = "Inicia sesión o regístrate";
    } else if(this.isEmail) {
      response = "Inicia sesión o regístrate";
    }
    return response + " para continuar";
  }

  get getInputLabel() {
    let response = "";
    if(this.isCellphone && !this.isEmail) {
      response = "Teléfono celular";
    } else {
      response = "Correo electrónico";
    }
    return response;
  }

  get isEnableButton() {
    if (this.isEmail) {
      if (this.isUser) {
        this.enableButton =
          this.emailValue &&
          this.emailValue.length > 0 &&
          this.passwordValue &&
          this.passwordValue.length > 0;
      } else {
        this.enableButton = this.emailValue && this.emailValue.length > 0;
      }
    }
    return this.enableButton;
  }

  mounted() {
    this.isCellphone = true;
    this.setPageTitle();
    const w = window as any;
    try {
      // w.Intercom('update', {
      //   hide_default_launcher: true
      // });
    } catch (error) {
      // Do Nothing!
    }
  }

  setPageTitle() {
    if (window && window.document && window.document.title) {
      window.document.title = `Iniciar sesión - TodosComemos`;
    }
  }

  async _send() {
    this.loading = true;
    if (this.isCellphone) {
      if (
        this.cellphoneValue &&
        this.cellphoneValue.length &&
        this.correct
      ) {
        let isLogin = true;
        this.loginHelper.cellphoneValue = this.cellphoneValue;
        this.loginHelper.emailValue = "";
        try {
          const res = await this.action_getLoginCellSearch(this.cellphoneValue);
          this.loginHelper.isLogin = true;
        } catch (error) {
          this.loginHelper.isLogin = false;
        }
        this.LOGIN_HELPER(this.loginHelper);
        this.$router.push({ 
          name: 'loginCellCode', 
          query: {
            cellphone: this.cellphoneValue,
            type: isLogin ? 'login' : 'sign_up'
        }});
      }

    } else if (this.isEmail) {
      if(this.isUser) {
        await this._emailLogin();
      } else {
        await this._checkEmail();
      }
    }
    this.loading = false;
  }

  _routeLogin() {
    if (this.getPathTemporal) {
      this.$router.push(this.getPathTemporal);
    } else {
      this.$router.push({ name: 'root' })
    }
  }

  get getMainButtonText() {
    let response = "";
    if( !this.isSignUp && (this.isCellphone || this.isEmail)) {
      response = "Continuar";
    } else {
      response = "Continuar";
    }
    return response;
  }

  async _emailLogin() {
    try {
      // @ts-ignore
      this.$ga.event('Login', 'Login', 'Email')
      this.loading = true;
      const user = {
        email: this.emailValue,
        password: this.passwordValue
      }
      await this.action_postLogin(user);
      let cityId = 3;
      if(this.getCity && this.getCity.id) {
        cityId = this.getCity.id;
      }
      await this.action_changeUserCommerce({
        normal_user: {
          commerce_id: cityId
        }
      });
      this._routeLogin();
    } catch (error) {
      // revismos si llego un error por el usuario
      this.loading = false;
      this.correct = false;
      this.isWrong = "Correo electrónico o contraseña incorrectos.";
    }
  }

  async _checkEmail() {
    try {
      await this.action_getLoginEmail(this.emailValue);
      this.isUser = true
      return
    } catch (error) {
      this.isUser = false
      this.$swal({
        title: "No encontramos tu cuenta",
        text: "No pudimos encontrar una cuenta asociada a la dirección de"+ 
        " correo que escribiste. Por favor, revísala e intenta de nuevo."
      });
    }
  }

  async _resetPassword() {
    if(this.isEmail && this.emailValue && this.emailValue.length) {
      try {
        await this.action_postResetPassword({ email: this.emailValue })
        this.$swal({
          imageUrl: '/assets/images/ui/cohete.png',
          imageWidth: 100,
          text: 'Se envió la información a su email'
        })
      } catch (error) {
        this.$swal({
          title: 'Error al intentar recuperar contraseña.',
          text: error.response.data.message
        })
      }
    } else {
      this.$swal({
        title: "Recuperar contraseña",
        text: "Ingresa tu dirección de correo para recuperar tu contraseña."
      });
    }
    
  }

  _onCellphoneValue(value) {
    if(value) {
      if(value.cellphone) {
        this.cellphoneValue = value.cellphone;
        this.correct = true;
        this.isWrong = "";
      } else if (value.wrong) {
        this.isWrong = value.wrong;
        this.correct = false;
      } else {
        this.isWrong = "";
        this.correct = false;
      }
      if(value.enableButton) {
        this.enableButton = value.enableButton;
      } else {
        this.enableButton = false;
      }
    }
  }

  _onChangeLoginMethod() {
    this.loading = true;
    setTimeout(() => {
      this.isEmail = !this.isEmail;
      this.isCellphone = !this.isCellphone;
      this.loading = false;
      this.correct = false;
      this.isWrong = "";
    }, 500);
  }

  _onSignUp() {
    this.loading = true;
    setTimeout(() => {
      this.isSignUp = !this.isSignUp;
      this.isEmail = false;
      this.isCellphone = true;
      this.loading = false;
    }, 1000);
  }

  goToMarketplace() {
    this.$router.replace({ name: 'root' });
  }

}
